import React from 'react';
import styled from 'styled-components';
import { Text, Flex, Wrapper, Heading } from './';
import { theme } from '../style';

const HeroContainer = styled.div`
  background-image: ${({ images }) =>
    `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${images[2]}), url(${images[1]}), url(${images[0]})`};
  background-size: auto, contain, auto 550px, cover;
  background-position: center, right, calc(50% + 50px) 5%, 50% 70%;
  background-repeat: no-repeat;

  @media ${theme.devices.md} {
    background-size: auto, contain, auto 450px, cover;
  }

  .description {
    @media ${theme.devices.md} {
      display: none;
    }
  }
`;

const Hero = ({ data }) => {
  const { headingTitle, headingSubtitle, headingBackground } = data || {};
  const { bgFirst, bgSecond, bgThird } = headingBackground || {};

  return (
    <>
      {Object.values(headingBackground).some((value) => value) ? (
        <HeroContainer
          images={[bgFirst?.sourceUrl, bgSecond?.sourceUrl, bgThird?.sourceUrl]}
        >
          <Wrapper>
            <Flex
              flexDirection="column"
              justifyContent="center"
              minHeight={[300, 400, 400, 500]}
              width={['100%', '80%', '80%', '60%']}
              pt={100}
              pb={20}
              mx={[0, 2, 3, 5]}
            >
              <Text
                as="h1"
                color="white"
                fontWeight="bold"
                textShadow="0em 0.1em 0.1em rgb(0 0 0 / 40%)"
                dangerouslySetInnerHTML={{ __html: headingTitle }}
              />
              <Text
                as="h4"
                color="white"
                className="description"
                mt={3}
                dangerouslySetInnerHTML={{
                  __html: headingSubtitle,
                }}
              />
            </Flex>
          </Wrapper>
        </HeroContainer>
      ) : (
        <Wrapper>
          <Heading title={headingTitle} description={headingSubtitle} />
        </Wrapper>
      )}
    </>
  );
};

export default Hero;
